import { BrowserRouter, Route, Routes } from 'react-router-dom';
import DocumentPicker from './pages/DocumentPicker';
import NotFound from './pages/NotFound';
import FinancialPoaForm from './pages/poa/FinancialPoaForm';
import FinancialPoaPreparation from './pages/poa/FinancialPoaPreparation';
import ReviewPOA from './pages/poa/ReviewPOA';
import SharePOA from './pages/poa/SharePOA';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DocumentPicker />} />
        <Route path="/poa/financial" element={<FinancialPoaPreparation />} />
        <Route path="/poa/financial/form" element={<FinancialPoaForm />} />
        <Route path="/poa/financial/review" element={<ReviewPOA />} />
        <Route path="/poa/financial/share" element={<SharePOA />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
